// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : Removed the unused 'line' and 'AutoLoan Index'
// MODFIED DATA : 01-08-2025
import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** GET PRE CLOSE LOAN MEMBER DETAILS START *********************** */
export const preCloseLoanMemberListGet = (listData: any) => {
	const data = {
		fetchPreCloseMemberListToken: listData,
	};
	const url = `${API_URL}preCloseLoanMemberDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET PRE CLOSE LOAN MEMBER DETAILS END *********************** */

/** ***************** UPDATE PRE CLOSE LOAN START *********************** */
export const PreCloseLoanMemberListUpdate = (listData: any) => {
	const data = {
		UpdatePreCloseMemberDetailToken: listData,
	};
	const url = `${API_URL}updatePreCloseMemberDetails`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE PRE CLOSE LOAN END *********************** */

/** ***************** REVERT PRE CLOSE LOAN MEMBER DETAILS START *********************** */
export const PreCloseLoanMemberListRevert = (listData: any) => {
	const data = {
		RevertPreCloseMemberDetailToken: listData,
	};
	const url = `${API_URL}revertPreCloseMemberDetails`;
	return makeApiCall(url, data);
};
/** ***************** REVERT PRE CLOSE LOAN MEMBER DETAILS END *********************** */

/** ***************** GET BRANCH EOD DETAILS START *********************** */
export const BranchEODDetails = (listData: any) => {
	const data = {
		GetBranchEODExistPreCloseDetailsToken: listData,
	};
	const url = `${API_URL}getBranchEODExistPreClose`;
	return makeApiCall(url, data);
};
/** ***************** GET BRANCH EOD DETAILS END *********************** */
